import { ImageService } from "@DavisDigital/davisdigitalfrontend.module";

class ImageCollectionShareModalController {
    
    private close:Function; //injected from modal-service
    public baseObject:any;
    public superUser: boolean;
    
    public sharedWithTeacher:any;
	public sharedWithStudent:any;
	public sharedAsDavisCollection:any;
	public sharedAsBookCollection:any;
    
    public title:string = "";
    public isLoading:boolean = false;
	private previouslyFocusedElement: HTMLElement | null = null;
	private focusableSelector = 'button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])';
	// @ngInject
	constructor(
		public imageService   : ImageService,
		public $element,
		public $timeout         : ng.ITimeoutService,
	){}
	
	public $onInit = () => {
		// Store the element that had focus before the modal opened
		this.previouslyFocusedElement = document.activeElement as HTMLElement;
        //initialize properties
        this.title = this.baseObject.title;
    	this.sharedWithTeacher = this.baseObject.sharedWithTeacher == 1;
    	this.sharedWithStudent = this.baseObject.sharedWithStudent == 1;
    	this.sharedAsDavisCollection = this.baseObject.daiImageSetFlag == 1;
    	this.sharedAsBookCollection = this.baseObject.bookImageSetFlag == 1;
		// Set initial focus to the close button after render
		this.$timeout(() => {
			const modalEl = this.$element[0].querySelector('.modal');
			if (modalEl) {
				modalEl.removeAttribute('aria-hidden');
				const closeBtn = modalEl.querySelector('.close') as HTMLElement;
				if (closeBtn) {
					closeBtn.focus();
				}
			}
		});
	}
	
	
	public onCloseModal = () =>{
		this.close();
		// Restore focus to the previously focused element
		if (this.previouslyFocusedElement && this.previouslyFocusedElement.focus) {
			this.previouslyFocusedElement.focus();
		}
	}
	public handleKeydown = (event: KeyboardEvent) => {
		if (event.key === 'Escape' || event.keyCode === 27) {
			event.preventDefault();
			// Same path as the Close buttons so focus restoration also runs on Esc
			this.onCloseModal();
		}

		if (event.key === 'Tab' || event.keyCode === 9) {
			this.trapFocus(event);
		}
	}

	private trapFocus = (event: KeyboardEvent) => {
		const modalEl = this.$element[0].querySelector('.modal');
		if (!modalEl) return;

		// Only controls that can actually take focus right now; a disabled Save button
		// (while saving) would otherwise be "last" and the wrap check would never match.
		const focusableElements: HTMLElement[] = Array.prototype.filter.call(
			modalEl.querySelectorAll(this.focusableSelector),
			(el: HTMLElement) => !(el as HTMLButtonElement).disabled && el.getClientRects().length > 0
		);
		if (focusableElements.length === 0) return;

		const firstFocusable = focusableElements[0];
		const lastFocusable = focusableElements[focusableElements.length - 1];

		if (event.shiftKey) {
			if (document.activeElement === firstFocusable) {
				event.preventDefault();
				lastFocusable.focus();
			}
		} else {
			if (document.activeElement === lastFocusable) {
				event.preventDefault();
				firstFocusable.focus();
			}
		}
	}

	public onSubmitShare = () => {
		
		//return if isLoading is already true (it means another call is in process)
		if(this.isLoading){
			return;
		}
		//set isLoading to true (to prevent any other API call)
		this.isLoading = true;
		this.imageService.imageCollectionShare(this.baseObject.imageSetID, this.sharedWithStudent == 1, this.sharedWithTeacher == 1, this.sharedAsDavisCollection == 1, this.sharedAsBookCollection == 1).then( (result)=>{
			this.isLoading = false;
			if( result.successfulActions?.length ) {
				this.onCloseModal();
			}
		});
		
	}

}
    

class ImageCollectionShareModal {
	public restrict: string = 'E';
	public scope:{};
	
	public bindToController = {
	    superUser: "<",
	    baseObject: "<",
		close:'='
	};

	public controller = ImageCollectionShareModalController;
	public controllerAs = 'shareModal';
	
	public templateUrl = __DAVIS_FRONTEND_BASE_PATH__ + '/davisdigital/directives/modals/image-collection-share-modal.html';

	public static Factory() {
		return () => new this();
	}
}

export { ImageCollectionShareModal };
